import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { IAboutTeamValue } from '../interfaces/IAboutTeamValue';

const ABOUT_US_TEAM_VALUES: IAboutTeamValue[] = [
  {
    id: 1,
    title: 'Think.',
    value: 'think',
    body: 'We think critically, share different perspectives openly, question assumptions freely, and push each other every chance we get. ',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/our_values_1.png"
        alt="our values think"
      />
    ),
  },
  {
    id: 2,
    title: 'Do.',
    value: 'do',
    body: "We have a strong bias towards action, and we learn and adapt along the way. We don't get bogged down by indecision. We pick a lane and we hit the gas.",
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/our_values_2.png"
        alt="our values do"
      />
    ),
  },
  {
    id: 3,
    title: 'Serve.',
    value: 'serve',
    body: 'We are all about empowering others through service, because we believe that with service, trust and collaboration, anything is possible. ',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/our_values_1.png"
        alt="our values serve"
      />
    ),
  },
];

export default ABOUT_US_TEAM_VALUES;
